import React from 'react';
import { Link } from 'react-router-dom';
import { FaGraduationCap } from 'react-icons/fa';
import ScrollTopButton from './ScrollTopButton';

const FooterOne = () => {
    return (
        <>
            <footer className="eduvibe-footer-one edu-footer footer-style-default">
                <div className="footer-top">
                    <div className="container eduvibe-animated-shape">
                        <div className="row g-5">
                            <div className="col-lg-3 col-md-6 col-sm-12 col-12">
                                <div className="edu-footer-widget">
                                    <div className="logo">
                                        <Link to={process.env.PUBLIC_URL + "/"} style={{ textDecoration: 'none', display: 'flex', alignItems: 'center', gap: '10px' }}>
                                            <FaGraduationCap style={{ fontSize: '34px', color: '#C8A55A' }} />
                                            <span style={{ fontWeight: '700', fontSize: '17px', color: '#ffffff', lineHeight: '1.2', whiteSpace: 'nowrap' }}>
                                                Green Cap<br />
                                                <span style={{ fontWeight: '400', fontSize: '11px', color: '#aab0c0', letterSpacing: '0.8px' }}>HIGH SCHOOL</span>
                                            </span>
                                        </Link>
                                    </div>
                                    <p className="description">Green Cap High School — Education, Discipline, Moral. Shaping confident leaders and bright futures for Pakistan since 2004.</p>
                                    <ul className="social-share">
                                        <li><a href="#"><i className="icon-Fb"></i></a></li>
                                        <li><a href="#"><i className="icon-linkedin"></i></a></li>
                                        <li><a href="#"><i className="icon-Pinterest"></i></a></li>
                                        <li><a href="#"><i className="icon-Twitter"></i></a></li>
                                    </ul>
                                </div>
                            </div>

                            <div className="col-lg-3 col-md-6 col-sm-6 col-12">
                                <div className="edu-footer-widget explore-widget">
                                    <h5 className="widget-title">Explore</h5>
                                    <div className="inner">
                                        <ul className="footer-link link-hover">
                                            <li><Link to="/about-us-1"><i className="icon-Double-arrow"></i>About Us</Link></li>
                                            <li><Link to="/blog-grid-1"><i className="icon-Double-arrow"></i>News &amp; Updates</Link></li>
                                            <li><Link to="/contact-us"><i className="icon-Double-arrow"></i>Contact Us</Link></li>
                                            <li><Link to="/course-1"><i className="icon-Double-arrow"></i>Our Programs</Link></li>
                                        </ul>
                                    </div>
                                </div>
                            </div>

                            <div className="col-lg-3 col-md-6 col-sm-6 col-12">
                                <div className="edu-footer-widget quick-link-widget">
                                    <h5 className="widget-title">Our Programs</h5>
                                    <div className="inner">
                                        <ul className="footer-link link-hover">
                                            <li><Link to="/course-1"><i className="icon-Double-arrow"></i>Montessori &amp; Primary</Link></li>
                                            <li><Link to="/course-1"><i className="icon-Double-arrow"></i>Middle School</Link></li>
                                            <li><Link to="/course-1"><i className="icon-Double-arrow"></i>Matric (Grade 9–10)</Link></li>
                                            <li><Link to="/course-1"><i className="icon-Double-arrow"></i>Co-Curricular Activities</Link></li>
                                            <li><Link to="/about-us-1"><i className="icon-Double-arrow"></i>Admissions</Link></li>
                                            <li><Link to="/contact-us"><i className="icon-Double-arrow"></i>Contact Us</Link></li>
                                        </ul>
                                    </div>
                                </div>
                            </div>

                            <div className="col-lg-3 col-md-6 col-sm-6 col-12">
                                <div className="edu-footer-widget">
                                    <h5 className="widget-title">Contact Info</h5>
                                    <div className="inner">
                                        <div className="widget-information">
                                            <ul className="information-list">
                                                <li><i className="icon-map-pin-line"></i>Ferozepur Road, Lahore, Pakistan</li>
                                                <li><i className="icon-phone-fill"></i><a href="tel:+923364190221">0336 4190221</a></li>
                                                <li><i className="icon-mail-line-2"></i><a href="mailto:greencapschool123@gmail.com">greencapschool123@gmail.com</a></li>
                                                <li><i className="icon-global-line"></i><a href="https://www.greencaphighschool.com" target="_blank" rel="noreferrer">www.greencaphighschool.com</a></li>
                                            </ul>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>

                        <div className="shape-dot-wrapper shape-wrapper d-md-block d-none">
                            <div className="shape-image shape-image-1">
                                <img src="/images/shapes/shape-21-01.png" alt="Shape Thumb" />
                            </div>
                            <div className="shape-image shape-image-2">
                                <img src="/images/shapes/shape-35.png" alt="Shape Thumb" />
                            </div>
                        </div>
                    </div>
                </div>
                <div className="copyright-area copyright-default">
                    <div className="container">
                        <div className="row">
                            <div className="col-lg-12">
                                <div className="inner text-center">
                                    <p>Copyright 2024 <a href="#">Green Cap High School</a>. All Rights Reserved.</p>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </footer>
            <ScrollTopButton />
        </>
    )
}

export default FooterOne;